import Component from "@glimmer/component";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import { service } from "@ember/service";
import { t } from "ember-intl";
import IconsCheck from "glesys-controlpanel/components/icons/check";

export default class ValidationMessage extends Component {
  @service intl;

  <template>
    {{#if @visible}}
      <div class="w-full mb-2" {{mergeClasses}} ...attributes>
        <span
          class="py-1 px-2.5 text-xs rounded-full inline-flex items-center bg-gray-50 text-gray-500"
          data-test-validation-message={{@field}}
        >
          {{#if @isValid}}
            <IconsCheck class="size-3 -ml-0.5 mr-1 stroke-3 text-green-100" data-test-validation-check={{@field}} />
          {{/if}}
          {{t "organization.create.validation-requirement" field=@label count=@minLength}}
        </span>
      </div>
    {{/if}}
  </template>
}
